// 页面抽离统一管理
const baseConf = {
  // 基础品牌信息
  name: 'Weariya',
  companyName: 'Brightcom Commerce',
  address: 'SECOND FLOOR,OFFICE B 201,SKY HEIGHTS,KALYAN STATION ROAD,NEAR KALYAN STATION,Kalyan West,Kalyan,Thane,Maharashtra,421301',
  email: 'support@weariya.com',
  
  // 主题配置
  theme: {
    color: '#e9818d',
    secondary: '#ff8c42',
    success: '#28a745',
    warning: '#ffc107',
    danger: '#dc3545',
    info: '#17a2b8'
  },
  // 定制化配-倾向单独的配置-如首页模块文本色
  custom: {
    // 首页模块介绍文本
    homeIntroduceTitle: '#141312',
    homeIntroduceTitleFont: 'MyriadPro-BoldIt, sans-serif',
    homeIntroduceBg: '#f6f6f6', // 介绍模块背景色
    homeSwiperBg: '#f8f3f4', // 轮播图背景色
    homeNavBtn: '#010101' // 首页导航块按钮色
  },
  // SEO配置
  seo: {
    title: 'Weariya - Your Fashion Destination',
    description: 'Discover the latest fashion trends at Weariya. Shop quality clothing and accessories with fast shipping.',
    keywords: 'Weariya, fashion, clothing, online shopping, trendy clothes'
  },
  // 社交媒体
  social: {
    facebook: 'https://facebook.com/weariya',
    instagram: 'https://instagram.com/weariya',
    twitter: 'https://twitter.com/weariya',
    youtube: 'https://youtube.com/weariya'
  },
  
  // 功能开关
  features: {
    enableChat: true,
    enableWishlist: true,
    enableCompare: true,
    enableReviews: true,
    enableNewsletter: true
  }
};

const formatConf = (conf) => {
  const cssVars = {};
  
  // 处理主题配置
  Object.entries(conf.theme).forEach(([key, value]) => {
    // 将驼峰命名转换为中划线命名,例如: primaryColor -> --theme-primary-color
    cssVars[`--theme-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`] = value;
  });
  
  // 处理自定义配置
  Object.entries(conf.custom).forEach(([key, value]) => {
    cssVars[`--tc-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`] = value;
  });
  
  return {
    ...conf,
    cssVars
  };
};

export default formatConf(baseConf);